import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getTestIds } from '../../../../utils/TestIds';
import { Column } from '../../../Layout';
import { MobileRecordCard } from '../../../MobileRecordCard';
import { Typography } from '../../../Typography';
import { SchemaCell } from '../cells/SchemaCell/SchemaCell';
import { cardActionsContent, cardCellEditing, columnName, hasCardActionsContent, isShown, movesSubtitleOut, showsOwnValue, subtitleOf } from '../mobileCard/mobileCard';
import { CardActions } from './CardActions';
import { CardFieldValue } from './CardFieldValue';
import { nestedCardRows, withNestedRows } from './nestedCardRows';
export function TableMobileCards(param) {
    let { items, getRowId, fields, gray, cardVariant, rowActions, actionSlot, badgeColumn, mainColumn, trailingColumn, now, editingFor, isPending, children, testId } = param;
    const testIds = getTestIds(testId);
    const lastField = fields[fields.length - 1];
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 8,
        testId: testId,
        children: [
            items.map((row, index)=>{
                var _ref, _row_subItems;
                const rowId = (_ref = getRowId === null || getRowId === void 0 ? void 0 : getRowId(row, index)) !== null && _ref !== void 0 ? _ref : index;
                const cardTestId = testIds.card(rowId);
                const cardTestIds = getTestIds(cardTestId);
                const editing = editingFor === null || editingFor === void 0 ? void 0 : editingFor(row, rowId);
                const pending = (isPending === null || isPending === void 0 ? void 0 : isPending(rowId)) === true;
                const actionsContent = cardActionsContent({
                    row,
                    rowActions,
                    badgeColumn,
                    trailingColumn
                });
                return /*#__PURE__*/ _jsx(MobileRecordCard, {
                    skin: gray ? 'mobileGray' : undefined,
                    variant: cardVariant,
                    actions: hasCardActionsContent(actionsContent) ? /*#__PURE__*/ _jsx(CardActions, {
                        row: row,
                        content: actionsContent,
                        now: now,
                        editing: editing,
                        pending: pending,
                        cardTestId: cardTestId
                    }) : undefined,
                    actionsPlacement: actionsContent.trailing != null ? 'centered' : 'firstRow',
                    footer: actionSlot === null || actionSlot === void 0 ? void 0 : actionSlot(row, index),
                    inlineItems: fields.filter((field)=>field.inline && isShown(field, row)).map((field)=>{
                        const name = columnName(field.column);
                        return {
                            key: name,
                            testId: cardTestIds.inline(name),
                            content: /*#__PURE__*/ _jsx(SchemaCell, {
                                skin: "secondary",
                                column: field.column,
                                row: row,
                                now: now,
                                pending: pending && field.column.showsLoaderWhilePending === true,
                                editing: cardCellEditing(editing, field.column),
                                testId: cardTestIds.value(name)
                            })
                        };
                    }),
                    rows: withNestedRows({
                        own: fields.filter((field)=>!field.inline && isShown(field, row)).map((field)=>{
                            const name = columnName(field.column);
                            const isStrong = field.emphasis === 'strong';
                            const subtitle = movesSubtitleOut(field) && showsOwnValue(field, row) ? subtitleOf(field.column, row) : [];
                            return {
                                key: name,
                                layout: field.layout,
                                dividerBefore: field.dividerBefore,
                                emphasis: field.emphasis,
                                testId: cardTestIds.row(name),
                                dividerTestId: cardTestIds.divider(name),
                                label: field.label != null && showsOwnValue(field, row) ? (labelClassName)=>/*#__PURE__*/ _jsx(Typography, {
                                        skin: isStrong ? undefined : 'secondary',
                                        weight: isStrong ? 'normal' : undefined,
                                        className: labelClassName,
                                        testId: cardTestIds.label(name),
                                        children: field.hideColon ? field.label : "".concat(field.label, ":")
                                    }) : undefined,
                                value: (valueClassName)=>/*#__PURE__*/ _jsx("div", {
                                        className: valueClassName,
                                        children: /*#__PURE__*/ _jsx(CardFieldValue, {
                                            field: field,
                                            row: row,
                                            now: now,
                                            pending: pending,
                                            editing: editing,
                                            cardTestId: cardTestId
                                        })
                                    }),
                                secondaryTestId: cardTestIds.subtitle(name),
                                secondaryValue: subtitle.length === 0 ? undefined : (valueClassName)=>/*#__PURE__*/ _jsx("div", {
                                        className: valueClassName,
                                        children: subtitle.map((line, lineIndex)=>/*#__PURE__*/ _jsx(Typography, {
                                                ellipsis: true,
                                                skin: "secondary",
                                                children: line
                                            }, lineIndex))
                                    })
                            };
                        }),
                        nested: nestedCardRows({
                            nested: (_row_subItems = row.subItems) !== null && _row_subItems !== void 0 ? _row_subItems : [],
                            mainColumn,
                            valueField: lastField,
                            now,
                            cardTestId
                        })
                    }),
                    testId: cardTestId
                }, rowId);
            }),
            children
        ]
    });
}
